
    export const daffodillogo = "/images/daffodillogo.jpg";
    export const inactive_starIcon = "/images/inactive_star.png";
    export const active_starIcon = "/images/active_icon.png";
    export const flowerIcon = "/images/flower.png";
    export const feedbackImage = "/images/feedbackButton.png";
    export const doneIcon = "/images/done.png";
    export const refferIcon = "images/reffer.png";
    export const checkIcon = "images/checkIcon.png";
    export const crossIcon = "images/cross.png";
    

   